import { ModuleName, moduleName } from '@edgvr-front/modules/domain';
import { Validate } from '@edgvr-front/util/validate';
import {
  DataId,
  DataModuleEntityId,
  DataStartedAt,
  DataModuleEntityRaw as DataModuleEntityRaw0,
} from '../interface';
import { dataId, dataModuleEntityId, dataStartedAt } from '../schema';
import { DataModuleVO, DataVO } from '../vo';

export class DataModuleEntity {
  private static validation = Validate.compile(
    DataModuleEntity.validationSchema(),
    DataVO,
    DataModuleVO
  );

  constructor(readonly value: DataModuleEntityRaw) {
    Validate.assert(DataModuleEntity.validation, value);
  }

  toJSON() {
    return {
      ...this.value,
      data: this.value.data.toJSON(),
      dataModule: this.value.dataModule.toJSON(),
    };
  }

  static factory(dataModuleEntityRaw0: DataModuleEntityRaw0) {
    return new DataModuleEntity({
      ...dataModuleEntityRaw0,
      data: DataVO.factory(dataModuleEntityRaw0.data),
      dataModule: DataModuleVO.factory(dataModuleEntityRaw0.dataModule),
    });
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: [
        'id',
        'moduleName',
        'dataId',
        'data',
        'dataModule',
        'startedAt',
      ],
      properties: {
        id: dataModuleEntityId,
        moduleName,
        dataId,
        data: {
          instanceof: DataVO.name,
        },
        dataModule: {
          instanceof: DataModuleVO.name,
        },
        startedAt: dataStartedAt,
      },
      additionalProperties: false,
    };
  }
}

interface DataModuleEntityRaw {
  id: DataModuleEntityId;
  moduleName: ModuleName;
  dataId: DataId;
  data: DataVO;
  dataModule: DataModuleVO;
  startedAt: DataStartedAt;
}
